import * as authService from '../app/services/authService'
import {get} from 'lodash'
import swal from 'sweetalert2'

const devEnvironment = process.env.NODE_ENV === 'development'

/**
 * Handle API messages. *
 */
export default {
  async success (response, store) {
    // Update the list of excluded routes
    const config = get(response, 'config')
    let routes = store.getters.axiosExcludeRoutesErrorMessage
    if (routes.some(item => item === config.url)) {
      routes = routes.filter(item => item !== config.url)
      await store.dispatch('axiosExcludeRoutesErrorMessage', routes)
    }
    return response
  },
  async error (error, router, store) {
    const config = get(error, 'response.config')
    const swalData = {
      type: 'warning',
      title: 'Atenção',
      message: 'Falha ao realizar operação'
    }
    let logoutUser = false

    try {
      // API Timeout
      if (error.toString().includes('timeout')) {
        let timeoutMessage = ''
        if (devEnvironment) {
          timeoutMessage = '[API TIMEOUT]'
        }
        swalData.message = timeoutMessage += ' A sua solicitação está demorando muito, tente novamente mais tarde'
        console.error(timeoutMessage)
      } else {
        // Get status code
        const status = get(error, 'response.status')
        // Get error message
        const responseData = get(error, 'response.data') || 'Falha ao realizar operação'
        // Get error message body
        const responseMessage = get(responseData, 'message')
        // Get error object of messages
        const responseError = get(responseData, 'error')

        /**
         * Authorization errors
         */
        if ([401, 403].indexOf(status) > -1) {
          // Token expired force logout
          if ((responseMessage && (responseMessage === 'Token has expired')) ||
            responseError && responseError === 'Token expired') {
            logoutUser = true
            swalData.message = 'Sua sessão expirou, faça login novamente para continuar'
          } else {
            swalData.message = responseError
          }
        }

        /**
         * Wrong/Missing data or Validation errors
         */
        if ([400, 422].indexOf(status) > -1) {
          swalData.message = responseError
        }

        /**
         * WebServer error
         */
        if ([500].indexOf(status) > -1) {
          swalData.message = 'Foi encontrado um erro ao processar a sua operação, por favor tente novamente mais tarde'
          swalData.type = 'error'
        }

        /**
         * WebServer in Maintenance
         */
        if ([503].indexOf(status) > -1) {
          swalData.message = 'O sistema está em processo de atualização, por favor tente novamente mais tarde'
          swalData.type = 'error'
        }
      }

      // Show alert modal if route isn't in the excludes routes
      let routes = store.getters.axiosExcludeRoutesErrorMessage
      if (!routes.some(item => item === config.url)) {
        swal({title: swalData.title, html: swalData.message, type: swalData.type})
      }

      // Logout user
      if (logoutUser) {
        authService.logout().then(() => router.push({name: 'login'}))
      }
    } catch (e) {
      let routes = store.getters.axiosExcludeRoutesErrorMessage
      if (!routes.some(item => item === config.url)) {
        swal({
          title: swalData.title,
          html: 'Aconteceu um erro de comunicação, tente novamente mais tarde',
          type: swalData.type
        })
      }
      if (devEnvironment) {
        console.error('[API CONNECTION ERROR]')
      }
    }
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/http/messages.js